import NavigationBar from "./components/navigationBar";
import React from "react";
import { Box } from "@mui/material";
import { companyLogo, aboutImage } from "./assets/commonComponents/images";
import useMediaQuery from '@mui/material/useMediaQuery';
import { bannerData, navigationData, footerData, teamMembers, bannerImages, aboutData, aboutHeading, aboutSubHeading, contactDetails, contactHeadingText, contactSubHeadingText, formFields, teamHeadingText, contactButtonText, footerButtonText, COMPANY_INFO, SOCIAL_LINKS, teamSubHeadingText, servicesData, serviceHeadingText, serviceSubHeadingText } from "./assets/commonComponents/data";
import BannerCard from "./components/bannerCard";
import AboutCard from "./components/aboutSection";
import BankServices from "./components/serviceCard";
import TeamSection from "./components/teamCard";
import Footer from "./components/footerCard";
import ContactForm from "./components/contactCard";
import ChatPopUp from "./components/chatPopUp";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import ArticlePage from "./Pages/articlePage/ArticlePage";
import SidebarWithContent from "./Pages/documentPage/documentPage";
import BusinessToolCards from "./Util/UtilCategoryCard/UtilCategoryCard"
import UtilHeader from "./Util/UtilHeader/UtilHeader"
import bannerImage from "./assets/images/bannerImage.jpg"
import ScrollToTop from "./components/ScrollToTop";
// Wrapper component to pass navigate to components
console.log = () => { }
console.error = () => { }
function AppContent() {
  const isMobile = useMediaQuery("(max-width:768px)");
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const navigate = useNavigate(); // Hook for navigation

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (location.pathname !== "/" && id !== "knowledgebase") {
      // Navigate to homepage first
      navigate("/");
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const targetElement = document.getElementById(id);
        if (targetElement) {
          const yOffset = -80;
          const y = targetElement.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else {
        }
      }, 100); // Small delay to ensure DOM is updated
    } else if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    } else {
      console.log("Element not found:", id);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box id="nav">
        <NavigationBar
          logo={companyLogo}
          isMobile={isMobile}
          drawerOpen={drawerOpen}
          toggleDrawer={toggleDrawer}
          handleScroll={handleScroll}
          navigationData={navigationData}
        />
        {
          location.pathname != "/" &&

          <UtilHeader />
        }
      </Box>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Box id="home">
                <BannerCard bannerImages={bannerImages} bannerData={bannerData} sideImage={bannerImage} />
              </Box>
              <Box id="about">
                <AboutCard data={aboutData} />
              </Box>

              <Box id="service">
                <BankServices isMobile={isMobile} data={servicesData} headingText={serviceHeadingText} subHeadingText={serviceSubHeadingText} />
              </Box>
              <Box id="team">
                <TeamSection data={teamMembers} headingText={teamHeadingText} subHeadingText={teamSubHeadingText} />
              </Box>
              <Box id="contact">
                <ContactForm
                  details={contactDetails}
                  formData={formFields}
                  headingText={contactHeadingText}
                  subHeadingText={contactSubHeadingText}
                  buttonText={contactButtonText}
                />
              </Box>

            </>
          }
        />

        <Route path="/knowledgebase" element={<BusinessToolCards />} />
        <Route path="/knowledgebase/article/:search/:id" element={<ArticlePage />} />
        <Route path="/knowledgebase/document/:recordid" element={<SidebarWithContent />} />
      </Routes>
      <Box>
        <Footer
          data={footerData}
          buttonText={footerButtonText}
          companyInfo={COMPANY_INFO}
          mediaData={SOCIAL_LINKS}
          handleScroll={handleScroll}
        />
        <ChatPopUp />
      </Box>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;